import Image from 'next/image';
import styles from './scss/policy.module.scss';
import MainHeader from './component/header';
import MainFooter from './component/footer';

export default function PrivacyPolicy() {

    return (
        <>
            <MainHeader />

            <div className={styles.policy}>

                <div className={styles.maincontainer}>
                    <h3>Privacy Policy</h3>

                    <h4>About Us</h4>
                    <p>At Beatmyshop, we are committed to respecting your privacy and ensuring the protection of your personal data. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services. By using our site, you consent to this Privacy Policy.</p>
                    <h4>Data We Collect</h4>
                    <p>We may collect the following types of personal data depending on your interaction with our services:</p>
                    <ol>
                        <li><span>Visitor Identification:</span>Visitor ID (cookie), first name, last name, address, country, city, postcode, phone number, and email address.</li>
                        <li><span>Search Information:</span>Search queries, search history, and visitor data such as form type and search patterns.</li>
                        <li><span>Web Access Details:</span>IP address, browser type, device type, domain names, access times, requested pages, and referral websites.</li>
                        <li><span>Merchant Information:</span>If you are a retailer we may collect your account details, business name, customer order information, and clickstream data.</li>
                        <li><span>Payment Information:</span>While we do not store your payment data, we may use third-party payment processors for transactions. Your payment information is handled securely in compliance with legal standards.</li>
                        <li><span>Communication Data:</span>We collect your name, email address, and the content of any communications or enquiries you send to us.</li>
                    </ol>

                    <h4>How Your Information is Used</h4>
                    <p>We use the data collected for the following purposes:</p>
                    <ol>
                        <li><span>Service Information:</span>To deliver price comparison services and ensure our website operates efficiently.</li>
                        <li><span>Statistical Analysis:</span>To generate data and reports on user behaviour, which helps us improve our services and enhance user experience.</li>
                        <li><span>Legal Compliance:</span>To meet legal obligations and respond to requests from law enforcement or regulatory authorities.</li>
                        <li><span>Site Traffic and Usage:</span>To monitor and analyse site traffic and usage patterns to better understand user interactions and optimise website performance.</li>
                    </ol>

                    <h4>Categories of Data Processed</h4>
                    <p>When you visit our website, we automatically collect the following technical information:</p>
                    <ul>
                        <li>Browser type and version.</li>
                        <li>Operating system..</li>
                        <li>Date and time of access..</li>
                        <li>Web pages visited before and after accessing our site..</li>
                        <li>User profile data (e.g., cookie ID, ad ID)..</li>
                    </ul>

                    <h4>Your Rights</h4>
                    <p>Under GDPR, you have the following rights concerning your personal data:</p>
                    <ol>
                        <li><span>Right to Access:</span>You can request a copy of the data we hold about you.</li>
                        <li><span>Right to Rectification:</span>You can ask us to update or correct your personal data.</li>
                        <li><span>Right to Erasure:</span>You can request the deletion of your data in certain circumstances.</li>
                        <li><span>Right to Restrict Processing:</span>You can request that we limit the use of your data.</li>
                        <li><span>Right to Object:</span>You can object to how we process your data, including for marketing purposes.</li>
                    </ol>

                    <h4>Data Retention</h4>
                    <p>We retain your data for as long as necessary to fulfil the purposes for which it was collected or as required by law. Data collected with your consent will be stored until you withdraw your consent.</p>

                    <h4>Data Security</h4>
                    <p>We use a variety of security measures to protect your personal data from unauthorised access, alteration, disclosure, or destruction. Access to personal data is restricted to authorised personnel, and sensitive data is encrypted.</p>

                    <h4>Cookie Policy</h4>
                    <p>We use cookies and similar tracking technologies to enhance user experience and improve our services. Cookies are small text files placed on your device by our website. We use the following types of cookies:</p>
                    <ol>
                        <li><span>Strictly Necessary Cookies:</span>Essential for the functioning of the site, such as remembering your login information.</li>
                        <li><span>Analytical/Performance Cookies:</span>Used to analyse site traffic and understand how users navigate the site, helping us improve functionality.</li>
                        <li><span>Functionality Cookies:</span>Allow us to remember your preferences and customise content based on your previous interactions with the site.</li>
                        <li><span>Targeting Cookies:</span>These track your visits to our site and help deliver relevant advertisements based on your interests.</li>
                    </ol>

                    <h4>Age Requirements</h4>
                    <p>Our site is intended for individuals who have reached the age of majority (18 years old). By using our site, you confirm that you are at least 18 years old. We are not responsible for any damages resulting from a user misrepresenting their age.</p>

                    <h4>Children's Privacy</h4>
                    <p>We do not knowingly collect data from children under the age of 13. If we become aware that a child under 13 has provided us with personal information, we will take steps to delete such information.</p>

                    <h4>Third Party Websites</h4>
                    <p>Our site contains links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We recommend reviewing their privacy policies before providing any personal information.</p>

                    <h4>Adverts and Sponsored Links</h4>
                    <p>Our website may display adverts and sponsored links from third parties. Clicking on these links is at your own risk. We are not liable for any damages arising from your interaction with external advertisers.</p>

                    <h4>Changes to this Privacy Notice</h4>
                    <p>We reserve the right to modify this Privacy Policy to reflect changes in our practices or legal obligations. We encourage you to review this policy periodically. Any updates will be posted on this page with the date of the latest revision.</p>


                    <h4>Contact Information</h4>
                    <p>If you have any questions about these Terms of Service, please contact us at:<br />Email: <a href="mailto:support@beatmyshop.co.uk">support@beatmyshop.co.uk</a><br />Phone: <a href="tel:+442034440000">+44 203 444 0000</a><br />Address: Worktual, Level 18, 40 Bank St, London E14 5NR, United Kingdom.</p>

                </div>
            </div>
            <MainFooter />
        </>
    );
}
